import i18n, { Resource } from 'i18next';
import { initReactI18next, useTranslation, I18nextProvider } from 'react-i18next';
import { InitI18n } from './models';

export const initI18n = async ({ getResources, debug }: InitI18n) => {
  const fallbackLng = 'en';
  const defaultNS = 'translation';
  const { resources, namespaces } = await getResources({ language: fallbackLng });

  return await i18n.use(initReactI18next).init(
    {
      compatibilityJSON: 'v3',
      fallbackLng,
      resources,
      debug,
      defaultNS,
      ns: namespaces,
      returnObjects: true,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
    },
    () => {}
  );
};

export { useTranslation, i18n, I18nextProvider };
export type { Resource };
export type { TFunction } from 'react-i18next';
